import auth0 from 'auth0-js';
import authConfig from '../auth-config';
import { BASE_URL, LOGOUT_URL } from '@/constants';

const webAuth = new auth0.WebAuth({
  domain: authConfig.domain,
  redirectUri: `${BASE_URL}/callback`,
  clientID: authConfig.clientId,
  audience: authConfig.audience,
  responseType: 'token id_token',
  scope: 'openid profile email'
});

class AuthService {
  login(returnToPath: string) {
    webAuth.authorize({
      appState: returnToPath
    });
  }

  logout() {
    webAuth.logout({
      returnTo: LOGOUT_URL
    });
  }

  handleAuthentication() {
    return new Promise((resolve, reject) => {
      webAuth.parseHash((err, authResult) => {
        if (err) {
          console.log(err);
          reject(err);
        } else {
          if (authResult && authResult.accessToken) {
            resolve(authResult);
          }
        }
      });
    });
  }
}

export default new AuthService();
